<h2 mat-dialog-title class="text-lg font-bold mb-1">
  {{ isEditMode ? "Editar Registro" : "Nuevo Registro" }}
</h2>
<mat-dialog-content class="modal-content">
  <form #createForm="ngForm" class="grid grid-cols-2 gap-4">
    <div class="col-span-2">
      <label>Actividad</label>
      <ng-select
        [(ngModel)]="currentCreateActivitie.activityId"
        [items]="activityList"
        bindLabel="name"
        bindValue="_id"
        [searchable]="true"
        placeholder="Seleccione una actividad"
        name="activityId"
        [appendTo]="'body'"
        required
      >
      
      <ng-template ng-label-tmp let-item="item">
        <span
          ><b>{{ item.code }}</b> - {{ item.name }}</span
        >
      </ng-template>

      <ng-template ng-option-tmp let-item="item">
        <span
          ><b>{{ item.code }}</b> - {{ item.name }}</span
        >
      </ng-template>
      </ng-select>
    </div>
    <div class="col-span-2">
      <label>Razón de Visita</label>
      <ng-select
        [(ngModel)]="currentCreateActivitie.defaultReasonVisitId"
        [items]="reasonVisitList"
        bindLabel="name"
        bindValue="_id"
        [searchable]="true"
        placeholder="Seleccione una razón de visita"
        name="defaultReasonVisitId"
        [appendTo]="'body'"
      >
      </ng-select>
    </div>

    <div class="col-span-2">
      <label>Tipo de Documento</label>
      <ng-select
        [(ngModel)]="currentCreateActivitie.documentTypeToCreateId"
        [items]="documentTypeList"
        bindLabel="name"
        bindValue="_id"
        [searchable]="true"
        placeholder="Seleccione un tipo de documento"
        name="documentTypeToCreateId"
        (ngModelChange)="onDocumentTypeSelectionChange($event)"
        [appendTo]="'body'"
      >
        <ng-template ng-label-tmp let-item="item">
          <span
            ><b>{{ item.code }}</b> - {{ item.name }}</span
          >
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <span
            ><b>{{ item.code }}</b> - {{ item.name }}</span
          >
        </ng-template>
      </ng-select>
    </div>

    <div class="col-span-2">
      <label>Clase de Documento</label>
      <ng-select
        [(ngModel)]="currentCreateActivitie.documentClassToCreateId"
        [items]="documentClassList"
        bindLabel="name"
        bindValue="_id"
        [searchable]="true"
        placeholder="Seleccione una clase de documento"
        name="documentClassToCreateId"
        [appendTo]="'body'"
        [disabled]="!isActivityCodeValid()"
      >
        <ng-template ng-label-tmp let-item="item">
          <span
            ><b>{{ item.code }}</b> - {{ item.name }}</span
          >
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <span
            ><b>{{ item.code }}</b> - {{ item.name }}</span
          >
        </ng-template>
      </ng-select>
    </div>

    <div class="col-span-1 flex items-center">
      <span class="slide">¿Aplicar en Liquidación?</span>
      <mat-slide-toggle
        [(ngModel)]="currentCreateActivitie.applyInLiquidation"
        name="applyInLiquidation"
        color="primary"
      >
      </mat-slide-toggle>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex">
  <button mat-button mat-dialog-close class="align-left">Cancelar</button>
  <button
    mat-raised-button
    color="primary"
    (click)="save()"
    [disabled]="!createForm.valid"
    class="justify-end"
  >
    {{ isEditMode ? "Actualizar" : "Guardar" }}
  </button>
</mat-dialog-actions>
